/**
 * A save is rejected when the configuration it was built from is no longer the
 * one stored. `AppAPIRepository::update()` answers that with
 * `workspace_conflict_refresh_required`, and `archive/request.js` turns every
 * failed response into a plain Error carrying the server message — so the
 * marker in the message is what identifies the conflict on this side.
 */
export const WORKSPACE_CONFLICT = "workspace_conflict_refresh_required";

export const isWorkspaceConflict = (error) =>
  Boolean(error && error.workspaceConflict)
  || String((error && error.message) || "").includes(WORKSPACE_CONFLICT);
